import styled from 'styled-components'

import colors from 'styles/colors'

export const StyledDateText = styled.span`
    color: ${colors.ashGray};
`

export const StyledBottomArea = styled.div`
    display: flex;
    flex-direction: column;
`

export const StyledBottomAreaText = styled.p`
    color: ${colors.slateBlueGray};
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 1.7rem;
    letter-spacing: 0.02em;
    margin: 2.5rem 0;
`

export const StyledBottomAreaBorder = styled.div`
    background-color: ${colors.platinumGray};
    height: 0.1rem;
    margin-bottom: 2rem;
`

export const StyledBottomAreaDetails = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
`

export const StyledBottomAreaDetailsLeft = styled.div`
    align-items: center;
    display: flex;
`

export const StyledAttachInfo = styled.div`
    align-items: center;
    display: flex;
    margin-right: 1rem;
`

export const StyledAttachImage = styled.img`
    width: 5rem;
    &:not(:last-child) {
        margin-right: 0.5rem;
    }
`

export const StyledAttachmentsWrapper = styled.div`
    display: flex;
`
